module.exports = __webpack_public_path__ + "static/media/icomoon.7c753ace.woff";